export const isGrid = (displaying: "grid" | "list"): boolean => {
  return displaying === "grid"
}